import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ChevronDown, ChevronRight, Award, Menu, X, ArrowRight } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_azure-seo-boost/artifacts/v4b4r58r_logo%20AT.png";

const SERVICES = [
  { nom: "Désinsectisation", url: "/desinsectisation" },
  { nom: "Dératisation", url: "/deratisation" },
  { nom: "Désinfection", url: "/desinfection" },
  { nom: "Punaises de lit", url: "/punaises-de-lit" },
];

const VILLES_PACA = [
  { nom: "Nice", url: "/nice" },
  { nom: "Cannes", url: "/cannes" },
  { nom: "Antibes", url: "/antibes" },
  { nom: "Grasse", url: "/grasse" },
  { nom: "Menton", url: "/menton" },
  { nom: "Cagnes-sur-Mer", url: "/cagnes-sur-mer" },
  { nom: "Saint-Laurent-du-Var", url: "/saint-laurent-du-var" },
  { nom: "Le Cannet", url: "/le-cannet" },
  { nom: "Vallauris", url: "/vallauris" },
  { nom: "Vence", url: "/vence" },
  { nom: "Beausoleil", url: "/beausoleil" },
  { nom: "Roquebrune-Cap-Martin", url: "/roquebrune-cap-martin" },
];

const VILLES_IDF = [
  { nom: "Paris", url: "/paris" },
  { nom: "Boulogne", url: "/boulogne" },
  { nom: "Versailles", url: "/versailles" },
  { nom: "Créteil", url: "/creteil" },
  { nom: "Montreuil", url: "/montreuil" },
  { nom: "Nanterre", url: "/nanterre" },
];

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm fixed w-full top-0 z-50 border-b border-gray-100">
      {/* Top bar - Desktop only */}
      <div className="bg-[#0f172a] text-white py-1.5 md:py-2 text-xs md:text-sm" data-testid="trust-banner">
        <div className="container mx-auto px-4 flex justify-between items-center">
          <div className="flex items-center space-x-2 md:space-x-3 overflow-hidden">
            <Award className="w-4 h-4 text-emerald-400 flex-shrink-0" />
            <span className="truncate">Entreprise certifiée • SIREN vérifié 821 012 630</span>
            <span className="text-gray-500 hidden sm:inline">•</span>
            <a href="https://share.google/DUrON8BOcFKaDm6vA" target="_blank" rel="noopener noreferrer" data-testid="trust-banner-google-link" className="flex items-center space-x-1 text-yellow-400 hover:text-yellow-300 font-semibold flex-shrink-0">
              <span>⭐ 5/5 Avis Google</span>
            </a>
          </div>
          <a href="mailto:azur.tech3d@yahoo.com" className="hidden md:flex items-center space-x-1 hover:text-emerald-400">
            <Mail className="w-4 h-4" />
            <span>azur.tech3d@yahoo.com</span>
          </a>
        </div>
      </div>

      <nav className="container mx-auto px-4 py-3">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center space-x-3">
            <img src={LOGO_URL} alt="Azur Tech" className="h-10 md:h-12 w-auto" loading="lazy" />
            <div className="hidden sm:block">
              <span className="text-lg md:text-xl font-bold text-[#0f172a] block">Azur Tech</span>
              <p className="text-xs text-gray-500">Expert Nuisibles</p>
            </div>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center space-x-5">
            <div className="relative group">
              <button className="flex items-center space-x-1 text-gray-700 hover:text-emerald-600 font-medium py-2">
                <span>Services</span>
                <ChevronDown className="w-4 h-4" />
              </button>
              <div className="absolute left-0 mt-0 w-48 bg-white rounded-xl shadow-xl border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50">
                <div className="p-2">
                  {SERVICES.map((s) => (
                    <Link key={s.url} to={s.url} className="flex items-center px-3 py-2 text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 rounded-lg text-sm">
                      <ChevronRight className="w-3 h-3 mr-2 text-emerald-500" />{s.nom}
                    </Link>
                  ))}
                </div>
              </div>
            </div>

            <div className="relative group">
              <button className="flex items-center space-x-1 text-gray-700 hover:text-emerald-600 font-medium py-2">
                <span>Zones</span>
                <ChevronDown className="w-4 h-4" />
              </button>
              <div className="absolute left-0 mt-0 w-52 bg-white rounded-xl shadow-xl border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50 max-h-80 overflow-y-auto">
                <div className="p-2">
                  <p className="px-3 py-1 text-xs font-bold text-emerald-600 uppercase">PACA</p>
                  {VILLES_PACA.map((v) => (
                    <Link key={v.url} to={v.url} className="block px-3 py-2 text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 rounded-lg text-sm">{v.nom}</Link>
                  ))}
                  <p className="px-3 py-1 text-xs font-bold text-emerald-600 uppercase mt-2 border-t pt-2">Île-de-France</p>
                  {VILLES_IDF.map((v) => (
                    <Link key={v.url} to={v.url} className="block px-3 py-2 text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 rounded-lg text-sm">{v.nom}</Link>
                  ))}
                </div>
              </div>
            </div>

            <Link to="/blog" className="text-gray-700 hover:text-emerald-600 font-medium">Blog</Link>
            <Link to="/galerie" className="text-gray-700 hover:text-emerald-600 font-medium">Galerie</Link>
            <Link to="/faq" className="text-gray-700 hover:text-emerald-600 font-medium">FAQ</Link>
          </div>

          {/* CTA */}
          <div className="flex items-center space-x-2">
            <a href="tel:0764079535" className="hidden md:flex items-center space-x-2 bg-[#0f172a] hover:bg-[#1e293b] text-white px-4 py-2.5 rounded-xl font-semibold text-sm">
              <Phone className="w-4 h-4" />
              <span>07 64 07 95 35</span>
            </a>
            <a href="/#devis" className="hidden sm:flex items-center space-x-1 bg-emerald-500 hover:bg-emerald-600 text-white px-4 py-2.5 rounded-xl font-semibold text-sm">
              <span>Devis gratuit</span>
              <ArrowRight className="w-4 h-4" />
            </a>
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden p-2 text-gray-700">
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t pt-4 space-y-1">
            <p className="text-xs font-bold text-emerald-600 uppercase px-2">Services</p>
            {SERVICES.map((s) => (
              <Link key={s.url} to={s.url} className="block px-3 py-2 text-gray-700 hover:bg-emerald-50 rounded-lg" onClick={() => setMobileMenuOpen(false)}>{s.nom}</Link>
            ))}
            <div className="border-t my-2"></div>
            <p className="text-xs font-bold text-emerald-600 uppercase px-2">Zones d'intervention</p>
            <div className="grid grid-cols-2 gap-1">
              {VILLES_PACA.slice(0, 8).map((v) => (
                <Link key={v.url} to={v.url} className="block px-3 py-2 text-gray-700 hover:bg-emerald-50 rounded-lg text-sm" onClick={() => setMobileMenuOpen(false)}>{v.nom}</Link>
              ))}
            </div>
            <div className="border-t my-2"></div>
            <Link to="/blog" className="block px-3 py-2 text-gray-700 hover:bg-emerald-50 rounded-lg" onClick={() => setMobileMenuOpen(false)}>Blog</Link>
            <Link to="/galerie" className="block px-3 py-2 text-gray-700 hover:bg-emerald-50 rounded-lg" onClick={() => setMobileMenuOpen(false)}>Galerie</Link>
            <Link to="/temoignages" className="block px-3 py-2 text-gray-700 hover:bg-emerald-50 rounded-lg" onClick={() => setMobileMenuOpen(false)}>Avis clients</Link>
            <Link to="/faq" className="block px-3 py-2 text-gray-700 hover:bg-emerald-50 rounded-lg" onClick={() => setMobileMenuOpen(false)}>FAQ</Link>
            <a href="tel:0764079535" className="block mx-2 mt-3 bg-emerald-500 text-white text-center font-bold py-3 rounded-xl">📞 07 64 07 95 35</a>
          </div>
        )}
      </nav>
    </header>
  );
}

export function Footer() {
  return (
    <footer className="bg-gray-900 text-white pt-12 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-2 mb-3">
              <img src={LOGO_URL} alt="Azur Tech" className="h-8 w-auto" loading="lazy" />
              <span className="font-bold">Azur Tech</span>
            </div>
            <p className="text-gray-400 text-sm">Expert en élimination de nuisibles depuis 2015. Intervention rapide en PACA et Île-de-France.</p>
          </div>
          <div>
            <h4 className="font-bold mb-3">Services</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              {SERVICES.map((s) => (
                <li key={s.url}><Link to={s.url} className="hover:text-emerald-400">{s.nom}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-3">Zones d'intervention</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/deratisation-nice" className="hover:text-emerald-400">Dératisation Nice</Link></li>
              <li><Link to="/desinsectisation-nice" className="hover:text-emerald-400">Désinsectisation Nice</Link></li>
              <li><Link to="/deratisation-cannes" className="hover:text-emerald-400">Dératisation Cannes</Link></li>
              <li><Link to="/desinsectisation-antibes" className="hover:text-emerald-400">Désinsectisation Antibes</Link></li>
              <li><Link to="/punaises-de-lit-nice" className="hover:text-emerald-400">Punaises de lit Nice</Link></li>
              <li><Link to="/grasse" className="hover:text-emerald-400">Grasse</Link></li>
              <li><Link to="/menton" className="hover:text-emerald-400">Menton</Link></li>
              <li><Link to="/cagnes-sur-mer" className="hover:text-emerald-400">Cagnes-sur-Mer</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-3">Infos</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/blog" className="hover:text-emerald-400">Blog</Link></li>
              <li><Link to="/faq" className="hover:text-emerald-400">FAQ</Link></li>
              <li><Link to="/temoignages" className="hover:text-emerald-400">Avis clients</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-3">Contact</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li className="flex items-center space-x-2">
                <Phone className="w-4 h-4 text-emerald-400" />
                <a href="tel:0764079535" className="hover:text-emerald-400">07 64 07 95 35</a>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="w-4 h-4 text-emerald-400" />
                <a href="mailto:azur.tech3d@yahoo.com" className="hover:text-emerald-400">azur.tech3d@yahoo.com</a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 text-emerald-400 mt-0.5" />
                <span>6 rue Miollis, 06000 Nice<br />PACA & Île-de-France</span>
              </li>
              <li>
                <a href="https://share.google/DUrON8BOcFKaDm6vA" target="_blank" rel="noopener noreferrer" className="hover:text-emerald-400">⭐ Nos avis Google vérifiés</a>
              </li>

            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-6 text-center text-gray-500 text-sm">
          <p>© {new Date().getFullYear()} Azur Tech - Tous droits réservés — SIREN 821 012 630 — <Link to="/mentions-legales" className="hover:text-emerald-400">Mentions légales</Link></p>
        </div>
      </div>
    </footer>
  );
}

export function StickyCTA() {
  return (
    <>
      {/* Mobile sticky bar */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-2 md:hidden z-50 shadow-lg">
        <div className="flex space-x-2">
          <a href="tel:0764079535" className="flex-1 flex items-center justify-center space-x-2 bg-[#0f172a] text-white py-3 rounded-xl font-semibold text-sm">
            <Phone className="w-4 h-4" />
            <span>Appeler</span>
          </a>
          <a href="/#devis" className="flex-1 flex items-center justify-center space-x-2 bg-emerald-500 text-white py-3 rounded-xl font-semibold text-sm">
            <span>Devis gratuit</span>
          </a>
        </div>
      </div>

      {/* WhatsApp */}
      <a
        href="https://wa.me/33764079535?text=Bonjour, j'ai besoin d'une intervention pour "
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-16 md:bottom-6 right-4 bg-green-500 hover:bg-green-600 text-white w-12 h-12 rounded-full shadow-xl flex items-center justify-center z-40"
        aria-label="WhatsApp"
      >
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
        </svg>
      </a>
    </>
  );
}

export function QuoteForm({ ville = "", service = "" }) {
  const [form, setForm] = useState({ name: "", phone: "", departement: "", email: "", service: service, message: "" });
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone || !form.departement || !form.service) { setStatus('error'); return; }
    setLoading(true);
    try {
      const data = {
        service_id: "service_rtzm46m",
        template_id: "template_h455el9",
        user_id: "Jh4VErtqqFa-xXiiT",
        template_params: { name: form.name, phone: form.phone, email: form.email || "Non renseigné", service: form.service, departement: form.departement, message: `[Département ${form.departement}] ${ville ? `[${ville}] ` : ""}${form.message}` }
      };
      await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', 'https://api.emailjs.com/api/v1.0/email/send', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = () => xhr.status === 200 ? resolve() : reject();
        xhr.onerror = reject;
        xhr.send(JSON.stringify(data));
      });
      setStatus('success');
      try {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/analytics/quote-submit`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ page: window.location.pathname, service: form.service }),
        });
      } catch (err) { /* silencieux */ }
      setForm({ name: "", phone: "", departement: "", email: "", service: "", message: "" });
    } catch { setStatus('error'); }
    setLoading(false);
  };

  return (
    <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
      <h3 className="text-xl font-bold text-[#0f172a] mb-1">Devis gratuit</h3>
      <p className="text-gray-500 text-sm mb-4">Réponse en moins de 15 min</p>
      
      {status === 'success' && (
        <div className="mb-4 p-3 bg-emerald-50 border border-emerald-200 rounded-lg text-emerald-700 text-sm">
          ✓ Demande envoyée ! On vous rappelle très vite.
        </div>
      )}
      {status === 'error' && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
          Erreur. Appelez-nous : 07 64 07 95 35
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-3">
        <input type="text" placeholder="Votre nom *" required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} disabled={loading}
          className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-1 focus:ring-emerald-200 outline-none text-sm" data-testid="sidebar-quote-name" />
        <input type="tel" placeholder="Téléphone *" required value={form.phone} onChange={(e) => setForm({...form, phone: e.target.value})} disabled={loading}
          className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-1 focus:ring-emerald-200 outline-none text-sm" data-testid="sidebar-quote-phone" />
        <input type="text" placeholder="N° de département * (ex : 06, 75)" required maxLength="3" value={form.departement} onChange={(e) => setForm({...form, departement: e.target.value})} disabled={loading}
          className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-1 focus:ring-emerald-200 outline-none text-sm" data-testid="sidebar-quote-departement" />
        <input type="email" placeholder="Votre email (optionnel)" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} disabled={loading}
          className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-1 focus:ring-emerald-200 outline-none text-sm" data-testid="sidebar-quote-email" />
        <select required value={form.service} onChange={(e) => setForm({...form, service: e.target.value})} disabled={loading}
          className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-emerald-500 outline-none text-sm bg-white" data-testid="sidebar-quote-service">
          <option value="">Type d'intervention *</option>
          <option value="Désinsectisation">Désinsectisation</option>
          <option value="Dératisation">Dératisation</option>
          <option value="Punaises de lit">Punaises de lit</option>
          <option value="Désinfection">Désinfection</option>
          <option value="Guêpes/Frelons">Guêpes / Frelons</option>
        </select>
        <textarea placeholder="Décrivez votre situation" rows="2" value={form.message} onChange={(e) => setForm({...form, message: e.target.value})} disabled={loading}
          className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-emerald-500 outline-none text-sm resize-none" data-testid="sidebar-quote-message" />
        <button type="submit" disabled={loading} data-testid="sidebar-quote-submit"
          className="w-full bg-emerald-500 hover:bg-emerald-600 text-white py-3 rounded-xl font-bold text-sm transition-all disabled:opacity-60">
          {loading ? "Envoi..." : "Recevoir mon devis gratuit →"}
        </button>
      </form>
      <p className="text-center text-xs text-gray-400 mt-3">Sans engagement • Gratuit</p>
    </div>
  );
}
